import React from 'react';

const getInitialColorScheme = (): string => {
    const attr = document.documentElement.getAttribute(
        'data-toolpad-color-scheme'
    );
    if (attr) return attr;
    return window.matchMedia('(prefers-color-scheme: dark)').matches
        ? 'dark'
        : 'light';
};

const useColorScheme = () => {
    const initial = getInitialColorScheme();
    const [colorScheme, setColorScheme] = React.useState(initial);
    const [backgroundColor, setBackgroundColor] = React.useState(
        initial === 'light' ? '#f0f0f0' : '#0d1117'
    );
    const [resizerColor, setResizerColor] = React.useState(
        initial === 'light' ? '#a7caed' : '#48657c'
    );
    const [fontColor, setFontColor] = React.useState(
        initial === 'light' ? '#0d1117' : '#f0f0f0'
    );

    React.useEffect(() => {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === 'data-toolpad-color-scheme') {
                    const newColorScheme = document.documentElement.getAttribute('data-toolpad-color-scheme');
                    if (newColorScheme) {
                        setColorScheme(newColorScheme);
                        setBackgroundColor(newColorScheme === 'light' ? '#f0f0f0' : '#0d1117');
                        setResizerColor(newColorScheme === 'light' ? '#a7caed': '#48657c');
                        setFontColor(newColorScheme === 'light' ? '#0d1117' : '#f0f0f0');
                    }
                }
            });
        });

        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['data-toolpad-color-scheme'],
        });

        return () => {
            observer.disconnect();
        };
    }, [colorScheme]);

    return { colorScheme, backgroundColor, resizerColor, fontColor };
};

export { useColorScheme };